import * as React from "react";
import { AccordionItem } from "components";
import { useParams } from "duck";
import { Notes, Timer } from "./components";

const TimerBlock: React.FC = () => {
  const { toothNumber } = useParams();

  return (
    <AccordionItem title={`${toothNumber} Timer`}>
      <Timer />
      <Notes />
    </AccordionItem>
  );
};

export default TimerBlock;
